module.exports = __webpack_public_path__ + "static/virgin-e5098f702a3ab4aa00e15624e91d7bc2.jpg";